import React from "react";
import { Filter, Loading } from "react-admin";
import { MonthRangeFilter } from "../../../components/filters/MonthRangeFilter";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { useTranslate } from "ra-core";
import { ThirdPartyInput } from "components/inputs/ThirdPartyInput";
import { CompanySelect } from "components/inputs";
import TextInputEx from "components/_extensions/react-admin/input/TextInputEx";

const getCreatedByApiCount = (data) => {
	let totalLength = 0;
	for (let key in data) {
		if (data[key] && Array.isArray(data[key]["order_ids"])) {
			totalLength += data[key]["order_ids"].length;
		}
	}
	return totalLength;
};


export const CreatedByApiCount = (props) => {
	const translate = useTranslate();
	if (!props.data) {
		return <Loading loadingSecondary="" />;
	}
	const totalLength = getCreatedByApiCount(props.data);

	return (
		<Box component="span" m={1}>
			<Typography variant="body2" color="secondary">
				{translate("resources.orders-by-api.created_count")}
				{totalLength}
			</Typography>
		</Box>
	);
};

export const OrdersByAPIListFilter = ({ isDeveloper, ...props }) => (
	<Filter {...props}>
		<MonthRangeFilter fromSource="completed_at:gte" toSource="completed_at:lte" alwaysOn />
		<CreatedByApiCount alwaysOn {...props} />
		{!isDeveloper ? 
			<TextInputEx source="oauth2_client_name" />
		: 
			<ThirdPartyInput source="oauth2_client_id" />
		}
		{!isDeveloper ? 
			<CompanySelect source="company_id" />
		: 
			<TextInputEx source="company_customer_name" />
		}
	</Filter>
);
